module.exports = __webpack_public_path__ + "static/media/fileManager.2de8eeab.svg";